import {EventEmitter, Injectable} from '@angular/core';
import {QueryParams} from "./query-params.model";
import {MessageService} from "../../messages/message.service";
import {AppConfigService} from "../../config/app-config.service";
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  urlChangeEvent = new EventEmitter<QueryParams>();

  matIds = new BehaviorSubject<string[]>([]);

  constructor(private messageService: MessageService,
              private appConfigService: AppConfigService) {
  }

  addEvent(queryParams: QueryParams) {
    if (this.calculateUrlLength(queryParams) < this.appConfigService.getConfig().maxUrlLength) {
      this.urlChangeEvent.emit(queryParams);
    } else {
      this.messageService.errorMessage('Filters.urlError.label', 'Filters.urlError.info');
    }
  }

  private calculateUrlLength(queryParams: QueryParams, filters?: string) {
    let urlConstParams = 'phrase'.length
      + '&'.length + 'page'.length + 1
      + '&'.length + 'searchInText'.length + 1;
    let urlExtraParams = 0;
    if (queryParams.phrase) {
      urlConstParams = queryParams.phrase.length;
    }
    if (queryParams.pageSize) {
      urlExtraParams = '&'.length + 'pageSize'.length + (queryParams.pageSize + '').length;
    }
    if (queryParams.sort) {
      urlExtraParams = '&'.length + 'sort'.length + queryParams.sort.length;
    }
    if (filters) {
      urlExtraParams = '&'.length + 'filters'.length + encodeURIComponent(filters).length;
    } else if (queryParams.filters) {
      urlExtraParams = '&'.length + 'filters'.length + encodeURIComponent(queryParams.filters).length;
    }
    return urlConstParams + urlExtraParams;
  }
}
